import { render, staticRenderFns } from "./LiveInfo.vue?vue&type=template&id=a8ddea8e&scoped=true&"
import script from "./LiveInfo.vue?vue&type=script&lang=js&"
export * from "./LiveInfo.vue?vue&type=script&lang=js&"
import style0 from "./LiveInfo.vue?vue&type=style&index=0&id=a8ddea8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ddea8e",
  null
  
)

export default component.exports